import { Tab } from "bootstrap";
import React, { useEffect, useState } from "react";
import { Tabs } from "react-bootstrap";
import "./WishlistTabs.css";
import WishlistPage from "./WishlistPage";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { fetchHeaderContent } from "../../../seoroute/redux/actions";

function WishlistTabs(props) {
  const { t } = useTranslation();
  const [detailTab, setDetailtab] = useState("store");

  useEffect(() => {
    callsetTab();
    // eslint-disable-next-line
  }, [props?.language, detailTab]);

  const callsetTab = () => {
    let title = "";
    if (detailTab === "store") {
      title = `${
        t("pages.sidenav.wishlist") + " (" + t("pages.wishlist.stores")
      })`;
    } else if (detailTab === "products") {
      title = `${
        t("pages.sidenav.wishlist") + " (" + t("pages.wishlist.products")
      })`;
    } else if (detailTab === "request") {
      title = `${t("pages.sidenav.wishlist") + " (" + t("pages.Request")})`;
    }
    props?.fetchHeaderContent(title, "", "");
  };

  const storedetailTabchange = (key) => {
    setDetailtab(key);
  };

  return (
    <div className=" wishtab-centent">
      <div className="card setting_card">
        <div className="card-body setting_body">
          <Tabs
            activeKey={detailTab}
            onSelect={(key) => storedetailTabchange(key)}
            className={"settings_tabs"}
          >
            <Tab
              eventKey="store"
              className={"setting_tab-content"}
              title={t("pages.wishlist.stores")}
            >
              <WishlistPage detailTab={detailTab} />
            </Tab>
            <Tab eventKey="products" title={t("pages.wishlist.products")}>
              {detailTab === "products" && (
                <WishlistPage detailTab={detailTab} />
              )}
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  type: state?.login.type,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchHeaderContent })(WishlistTabs);
